import { nullish } from 'Lib/type-sanity';

export default {
  methods: {
    $update(target) {
      if (!nullish(target)) {
        this.$asyncComputed[target].update();
      }
    },
    $updateAll() {
      for (const async_computed_prop of Object.values(this.$asyncComputed)) {
        async_computed_prop.update();
      }
    },
  },
};
